import BarcodeScan90daysController from './BarcodeScan90daysController';
import Loader from 'utils/Loader';
//import { greenColor, redColor, whiteColor } from 'utils/constants';
import { Box, Paper, Typography } from '@mui/material';
import React, { useDeferredValue, memo } from 'react';

const BarcodeCard = memo(function BarcodeCard({ item, onRemove }) {
  return (
    <Box
      sx={{
        border: '1px solid #d9d9d9',
        borderRadius: '6px',
        p: 1.5,
        backgroundColor: '#fafafa',
        contentVisibility: 'auto',
        containIntrinsicSize: '120px'
      }}
    >
      <Typography variant="caption" sx={{ color: '#666' }}>
        Barcode
      </Typography>
      <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
        {item.barcode}
      </Typography>

      <Typography variant="caption" sx={{ color: '#666' }}>
        Material
      </Typography>
      <Typography variant="body2" sx={{ mb: 1.5 }}>
        {item.materialDesc}
      </Typography>

      <button
        style={{
          fontSize: '12px',
          padding: '6px 8px',
          borderRadius: '3px',
          color: 'white',
          border: 'none',
          cursor: 'pointer'
        }}
        onClick={() => onRemove(item.barcode)}
      >
        Remove
      </button>
    </Box>
  );
});

function BarcodeScan90days() {
  const {
    barcodeText,
    barcodeData,
    isLoading,
    barcodeError,
    // handleOkButtonClick,
    handleClearButtonClick,
    handleTextareaResize,
    handleRemoveBarcode,
    handleProceed,
    handleBarcodesChange,
    handleBarcodesPaste,
  } = BarcodeScan90daysController();

  const deferredBarcodeData = useDeferredValue(barcodeData);
  const shouldRenderTable = deferredBarcodeData && deferredBarcodeData.length > 0;
  return (
    <div className="bg" style={{ display: 'block' }}>
      {isLoading ? (
        <div className="overlay">
          <Loader />
          <span style={{ marginLeft: '10px' }}>Data Loading...</span>
        </div>
      ) : null}
      <div className="cutrange">
        <span className="font20">BARCODE SCANNER SALES PLANNING</span>
      </div>
      {/* <div className="cutrange" style={{ justifyContent: 'end' }}>
        <span style={{ marginRight: '20px' }}>Total :</span>
        <input
          value={barcodeData.length}
          readOnly
          type="text"
          name="cfrom"
          style={{ width: '80px', marginRight: '20px', textAlign: 'center' }}
          className={`inp_text`}
          id="cfrom"
        />
      </div> */}
      <div className="vertical-center">
        <div style={{ display: 'flex', flexDirection: 'row', width: '80%' }}>
          <div style={{ flex: 1 }}>
            <textarea
              type="text"
              name="barcodes"
              value={barcodeText}
              className={`form-control inp_text`}
              id="barcodes"
              rows={7}
              cols={50}
              onChange={(e) => handleBarcodesChange(e)}
              onPaste={handleBarcodesPaste}
              onInput={handleTextareaResize}
              autoFocus
            />
          </div>
          {/* <div style={{ marginTop: 'auto', marginBottom: '10px', marginLeft: '10px' }}>
            <button onClick={handleOkButtonClick}>OK</button>
          </div> */}
        </div>
        <div style={{ width: '80%' }}>
          <p className="error">{barcodeError}</p>
        </div>
        {shouldRenderTable ? (
          <div className="barcode-so">
            <Paper
              elevation={3}
              sx={{
                width: '100%',
                margin: 'auto',
                borderRadius: '8px',
                overflow: 'hidden'
              }}
            >
              {/* <Box sx={{ px: 2, py: 1.5, borderBottom: '1px solid #e5e5e5' }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                  Barcode List ({barcodeData.length})
                </Typography>
              </Box> */}

              <Box
                sx={{
                  p: 2,
                  maxHeight: 420,
                  overflowY: 'auto',
                  overflowX: 'hidden',
                  display: 'grid',
                  gridTemplateColumns: {
                    xs: '1fr',
                    sm: 'repeat(2, minmax(0, 1fr))',
                    md: 'repeat(3, minmax(0, 1fr))'
                  },
                  gap: 1.5
                }}
              >
                {deferredBarcodeData.map((Item, Index) => (
                  <BarcodeCard
                    key={`${Item.barcode || 'barcode'}-${Index}`}
                    item={Item}
                    onRemove={handleRemoveBarcode}
                  />
                ))}
              </Box>
            </Paper>
          </div>
        ) : null}
      </div>

      <div className="footer-button">
        <button onClick={handleClearButtonClick} style={{ marginRight: '15px' }}>
          {'Clear'}
        </button>
        <button style={{ marginRight: '15px' }} onClick={handleProceed}>
          {'Proceed'}
        </button>
      </div>
    </div>
  );
}

export default BarcodeScan90days;
